/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Fit_TitleInputs */

const en_pc_alt_fit_title = /** @type {(inputs: Pc_Alt_Fit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where PdfCraft fits`)
};

const zh_pc_alt_fit_title = /** @type {(inputs: Pc_Alt_Fit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 适合的场景`)
};

/**
* | output |
* | --- |
* | "Where PdfCraft fits" |
*
* @param {Pc_Alt_Fit_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_fit_title = /** @type {((inputs?: Pc_Alt_Fit_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Fit_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_fit_title(inputs)
	return zh_pc_alt_fit_title(inputs)
});
export { pc_alt_fit_title as "pc.alt.fit_title" }